import React from "react";
import SvgIcn from "../../../data/IconCompo";
import PropTypes from "prop-types";

const ImageUploader = ({ image, imageUrl, onChange, error, fileInputRef }) => {
  return (
    <div className="form-group">
      {/* <label className="form-label">Item Image</label> */}
      <div
        className={`image-upload-area ${error ? "error" : ""}`}
        onClick={() => fileInputRef.current.click()}
      >
        {image || imageUrl ? (
          <div className="image-preview">
            <img
              src={image ? URL.createObjectURL(image) : imageUrl}
              alt="Preview"
              className="preview-img"
            />
          </div>
        ) : (
          <div className="upload-placeholder">
            <SvgIcn name="images" />
            <span>Click to upload image</span>
          </div>
        )}
        <input
          type="file"
          ref={fileInputRef}
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              onChange(file);
            }
          }}
          accept="image/*"
          style={{ display: "none" }}
        />
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

ImageUploader.propTypes = {
  image: PropTypes.object,
  imageUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  fileInputRef: PropTypes.object.isRequired,
};

export default ImageUploader;
